<div [class.isPrinting]="printService.isPrinting">
  <div class="row  margin-bottom-10px" id="edit-link">
    <div class="col-md-12">
      <div class="card box-shadow-new-treatmentcycle border-left-follicular" id="scans">
        <div class="card-header wh-header border-bottom-1px padding-top-0px padding-bottom-0px padding-left-0px padding-right-0px">
          <div class="row nav-link-hand margin-left-0px margin-right-0px border-bottom-tc">
            <div class="col-md-6 padding-right-0px">
              <label class="margin-bottom-0px font-size-16px font-weight-normal ">
                <!--<i class="fas fa-circle light-gray-badge nav-link-hand  ">
                </i>-->
                Follicular Scans
              </label>
            </div>
            <div class="col-md-6  padding-right-0px display-edit">
              <!--<a class="nav-link-hand education-navlink " title="To View images"><i class="far fa-image"></i></a>-->
              <div class="row float-right margin-left-0px margin-right-0px" *ngIf="SelectedTreatmentCycle">
                <div class="offset-md-5 col-md-3" *ngIf="!SelectedTreatmentCycle.IsReadyForPickup">
                  <button class="btn actions-btn-prime float-right font-size-15px " type="button" (click)="AddFollicularEventDetails()">
                    Add Follicular Scan
                  </button>
                </div>
                <div class="col-md-1  padding-left-0px padding-right-0px">
                  <!--<a class="nav-link-hand education-navlink data-color-new" title="To View images">
    <span class="badge font-size-20px padding-left-0px padding-right-0px padding-bottom-0px padding-top-0px"><i class="far fa-image"></i></span>
  </a>-->
                  <!--<a class="nav-link-hand education-navlink" title="print" (click)="printfollicular()">
                    <span class="badge font-size-16px padding-left-0px padding-top-0px padding-bottom-0px"><i class="fa fa-print"></i></span>
                  </a>-->
                  <button type="button" class="btn actions-btn-prime float-right font-size-15px padding-right-0px padding-left-0px min-width-32px" (click)="printfollicular2()"><i class="fa fa-print"></i></button>
                </div>
                <div class="col-md-1 padding-left-11px">
                  <button type="button" (click)="Top()"
                          class="btn  btn-sm drive-button4 background-primary border-all-secondary" id="FileUpload"
                          name="upload">
                    <i class="fas fa-arrow-alt-circle-up color-green font-size-18px"></i>
                    <!--<i class="fas fa-long-arrow-alt-up font-size-11"></i>-->
                  </button>

                </div>
                <div class="col-md-1 padding-left-11px">
                  <button type="button" (click)="Bottom()"
                          class="btn  btn-sm drive-button4 background-primary border-all-secondary" id="FileUpload"
                          name="upload">
                    <i class="fas fa-arrow-alt-circle-down color-green font-size-18px"></i>
                    <!--<i class="fas fa-long-arrow-alt-down font-size-11"></i>-->
                  </button>
                </div>

              </div>




            </div>

          </div>
        </div>
        <div class="card-body padding-top-0px padding-left-0px padding-right-0px">
          <div class="table-component overflow-x margin-top-10 margin-left-13px">
            <div class="table-responsive overflow-x">


              <table class="table table-striped margin-left-zero">

                <thead class="">
                  <tr>


                    <th class="font-weight-normal font-size-12px td-padding-tb td-width-107px">Date</th>
                    <th class="font-weight-normal font-size-12px td-padding-tb td-width-107px">DOC</th>
                    <th class="padding-left-0px font-size-12px font-weight-normal td-padding-tb td-width-162px">Endometrium</th>
                    <th class="font-weight-normal font-size-12px td-padding-tb padding-left-10px">Comments</th>
                    <th class="font-weight-normal font-size-12px td-padding-tb padding-left-10px">Ovaries Left</th>
                    <th class="font-weight-normal font-size-12px td-padding-tb padding-left-10px">Ovaries Right</th>
                    <th></th>
                    <!--<th></th>-->
                  </tr>
                  <!--<tr>
                    <th class="td-padding-tb "></th>
                    <th class="td-padding-tb"></th>
                    <th class="td-padding-tb font-weight-normal">Left</th>
                    <th class="td-padding-tb font-weight-normal">Right</th>
                  </tr>-->
                </thead>
                <tbody class="table-body">
                  <tr *ngFor="let s of CurrentFollicularScanDetailController">


                    <td class="padding-top-5px ">
                      <label class="margin-bottom-0px font-size-14"> {{s.ScanDate| date:'MMM-dd-yyyy'}}</label>

                    </td>
                    <td class="padding-top-5px ">
                      <label class="margin-bottom-0px font-size-14">{{s.DOC}}</label>
                    </td>
                    <td class="td-padding-tb padding-left-0px">
                      <div><label class="font-size-15px font-weight-bold color-Assign margin-bottom-0px">{{s.EndometriumThickness}}{{s.EndometriumThicknessUnits}}</label></div>
                      <div class="td-padding-tb td-elipsis2">{{s.EndometriumDetails}}</div>
                    </td>
                    <td class="padding-top-5px ">
                      <label class="margin-bottom-0px font-size-14">{{s.Comments}}</label>

                    </td>
                    <td class="td-padding-tb align-top td-padding-left-9px">
                      <!--<div>

    <label class="margin-bottom-0px">4(11.5)</label>
    </div>-->
                      <div class="row" *ngIf="CurrentFollicularScanOvaryDetailController.length > 0">
                        <div class="col-md-1 padding-right-23px margin-top-10 margin-right-18px margin-bottom-3px" *ngFor="let od of GetOvaryDetails(s.FollicularGrowth, 'Left')">
                          <div class="badge badge-service2-left margin-left-10px padding-top-0px padding-bottom-0px border-radius-0px">
                            <!--<div class="row">
            <label class="margin-bottom-0px margin-left-13px color-datacolor">4</label>
          </div>-->
                            <div class="badge inner-badge border-radius-50p">{{od.Count}}</div>
                            <label class="margin-top-4px font-size-15px margin-bottom-3px">{{od.Size}}</label>


                          </div>
                        </div>
                      </div>
                      <div class="row" *ngIf="CurrentFollicularScanOvaryDetailController.length == 0">
                        Ovary Details could not be fethced?? Please check!
                      </div>
                      <!--<div *ngFor="let l of CurrentFollicularScanOvaryDetailController">
      <label class="margin-bottom-0px">{{l.OvarPos}}</label>
    </div>-->


                    </td>

                    <td class="td-padding-tb align-top td-padding-left-9px">
                      <div class="row">
                        <div class="col-md-1 padding-right-23px margin-top-10 margin-right-18px" *ngFor="let od of GetOvaryDetails(s.FollicularGrowth, 'Right')">
                          <div class="badge badge-service2-right margin-left-10px padding-top-0px padding-bottom-0px border-radius-0px">
                            <!--<div class="row">
            <label class="margin-bottom-0px margin-left-13px color-datacolor">4</label>
          </div>-->
                            <div class="badge inner-badge border-radius-50p">{{od.Count}}</div>
                            <label class="margin-top-4px font-size-15px margin-bottom-3px">{{od.Size}}</label>


                          </div>
                        </div>

                      </div>
                      <!--<div><label class="margin-bottom-0px">3(13.2)</label></div>
    <div><label class="margin-bottom-0px">1(17.5)</label></div>-->
                    </td>


                    <td class="padding-top-0px padding-bottom-0px padding-left-0px padding-right-0px">
                      <div class="row">
                        <div *ngIf="SelectedTreatmentCycle">
                          <a class="nav-link-hand education-navlink  display-edit" title="Edit" (click)="Editscan(s)" *ngIf="ScanData2.ActivityStatus !=='Completed'">
                            <span class="badge font-size-14 padding-right-0px"><i class="fas fa-pencil-alt"></i></span>
                          </a>
                          <a class="nav-link-hand education-navlink" title="Detail" (click)="Editscan(s)" *ngIf="ScanData2.ActivityStatus =='Completed'">
                            <span class="badge font-size-16px padding-right-0px"><i class="fa fa-info-circle"></i></span>
                          </a>
                          <!--<a class="nav-link-hand education-navlink" title="Detail" (click)="Editscan(s)" *ngIf="SelectedTreatmentCycle.IsReadyForPickup">
                            <span class="badge font-size-16px padding-right-0px"><i class="fa fa-info-circle"></i></span>
                          </a>-->
                          <a class="nav-link-hand font-size-12px padding-left-5px color-Rejected" *canUserAccess="['DeleteFollicularScan']"
                             title="Remove" (click)="DeleteFollicularScan(s)">
                            <i class="far fa-trash-alt nav-link-hand"></i>
                          </a>
                        </div>
                        <a class="nav-link-hand padding-left-5px padding-top-5px education-navlink" title="print" (click)="SelectGrowthCode(s)">
                          <span class="badge font-size-16px padding-left-0px padding-top-0px padding-bottom-0px"><i class="fa fa-print"></i></span>
                        </a>
                      </div>
                      <!--<a class="nav-link-hand education-navlink display-edit" title="Click Here to View Test &amp; Medicines" (click)="ViewMedicines()">
      <span class="badge font-size-14">
        <i class="fas fa-external-link-alt"></i>
      </span>
    </a>-->
                    </td>
                    <!--<td class="padding-top-0px padding-bottom-0px padding-left-0px padding-right-0px">
    <a class="nav-link-hand education-navlink" title="print" (click)="SelectGrowthCode(s)">
      <span class="badge font-size-16px padding-left-0px padding-top-0px padding-bottom-0px"><i class="fa fa-print"></i></span>
    </a>
  </td>-->


                  </tr>

                </tbody>

              </table>
            </div>
          </div>

          <div class="row">
            <div class="col-md-12">
              <ivf-additional-detail [CycleCode]='CycleCode'
                                     Title="Additional Information"
                                     Context="FolScanAdnlDetail">
              </ivf-additional-detail>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>

  <router-outlet></router-outlet>
  <router-outlet name="print"></router-outlet>
</div>

